import React, { Fragment } from 'react';
import { Button } from 'antd';
import useAccountTypes from '../../../../queries/useAccountTypes';
import AddFieldsRow from '../../../common/formComponents/AddFieldsRow/AddFieldsRow';
import FieldsRow from '../../../common/formComponents/FieldsRow/FieldsRow';
import FormWrapper from '../../../common/formComponents/FormWrapper/FormWrapper';
import { getAddAccountFieldsData } from './utils/getAddAccountFieldsData';
import useAddField from '../../../../../../hooks/useAddField';
import FormDivider from '../../../common/formComponents/FormDivider/FormDivider';
import SelectFlat from '../common/SelectFlat';
import { texts } from '../../../../constants/texts';
import TreeSelectFlat from '../common/TreeSelectFlat';

const AddAccountForm = ({
  form,
  withSelectFlat = false,
  withSelectHouse = false,
  initialValues,
}) => {
  const { data: accountTypes, isFetching: isAccountTypesFetching } =
    useAccountTypes({ staleTime: Infinity });

  const {
    keys: accountKeys,
    add: addAccountFields,
    remove: removeAccountField,
  } = useAddField({
    form,
    name: 'accountKeys',
    initialNumOfFields: 1,
  });

  return (
    <FormWrapper>
      {withSelectHouse && <TreeSelectFlat form={form} />}
      {withSelectFlat && <SelectFlat form={form} />}
      {accountKeys.map((key, index) => (
        <Fragment key={key}>
          {index !== 0 && <FormDivider />}
          <FieldsRow
            form={form}
            gutter={10}
            rowType="field"
            index={key}
            fields={getAddAccountFieldsData(
              accountTypes,
              isAccountTypesFetching
            )}
          />
          {index !== 0 && (
            <Button
              type="danger"
              icon="delete"
              ghost
              onClick={() => removeAccountField(key)}
            >
              Удалить лицевой счет
            </Button>
          )}
        </Fragment>
      ))}
      <AddFieldsRow
        style={{ marginTop: '42px' }}
        withBorder
        text={texts.addAccount}
        rowType="field"
        addFieldsFunc={addAccountFields}
      />
    </FormWrapper>
  );
};

export default AddAccountForm;
